import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AVAILABILITY_STYLES } from "@/data/constants";

export default function ProductCard({ product }) {
  const badge = AVAILABILITY_STYLES[product.availability] || "bg-stone-100 text-stone-800 border-stone-300";
  const fallback = "https://images.unsplash.com/photo-1615485500834-bc10199bc727?w=800&q=80&auto=format";
  return (
    <div
      data-testid={`commodity-card-${product.slug}`}
      className="group bg-white border border-borderSubtle card-hover flex flex-col overflow-hidden"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-surface">
        <img
          src={product.image_url || fallback}
          alt={product.name}
          loading="lazy"
          onError={(e) => { if (e.currentTarget.src !== fallback) e.currentTarget.src = fallback; }}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className={`absolute top-3 left-3 text-[10px] uppercase tracking-widest font-semibold px-2.5 py-1 border ${badge}`}>
          {product.availability}
        </div>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="eyebrow mb-1.5">{product.category}</div>
        <h3 className="font-serif text-xl text-forest mb-2 leading-snug">{product.name}</h3>
        <p className="text-sm text-slateneutral leading-relaxed line-clamp-2 mb-4">{product.short_description}</p>
        <dl className="text-xs text-charcoal/70 space-y-1 mb-5">
          {product.origin && <div className="flex justify-between gap-2 border-b border-dashed border-borderSubtle py-1"><dt className="uppercase tracking-widest text-[10px]">Origin</dt><dd className="text-right">{product.origin}</dd></div>}
          {product.packaging && <div className="flex justify-between gap-2 border-b border-dashed border-borderSubtle py-1"><dt className="uppercase tracking-widest text-[10px]">Packaging</dt><dd className="text-right line-clamp-1">{product.packaging}</dd></div>}
        </dl>
        <div className="mt-auto flex items-center gap-2">
          <Link
            to={`/commodities/${product.slug}`}
            data-testid={`view-details-${product.slug}`}
            className="flex-1 text-center px-4 py-2.5 text-sm font-medium border border-forest text-forest hover:bg-forest hover:text-white transition"
          >
            View Details
          </Link>
          <Link
            to={`/quotation?product=${encodeURIComponent(product.slug)}`}
            data-testid={`quote-btn-${product.slug}`}
            className="flex-1 flex items-center justify-center gap-1.5 px-4 py-2.5 text-sm font-semibold btn-gold"
          >
            Request Quote <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
